import { useTranslation } from "react-i18next";
import { Box, useTheme, type BoxProps } from "~/common/mui";
import LinkIcon from "@mui/icons-material/Link";
import { TooltipWithArrow } from "~/common/components/TooltipWithArrow";

export const ConnectedEntriesChain = (props: BoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <TooltipWithArrow placement="top" title={t("product.phaseOut.info")}>
      <Box
        {...props}
        sx={{
          width: 55,
          height: 40,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...props.sx,
        }}
      >
        <svg
          width="55"
          height="40"
          viewBox="0 0 55 40"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            fill: theme.palette.primaryContainer.main,
            stroke: theme.palette.divider,
            strokeWidth: 1,
          }}
        >
          <path d="M 0.5 0.5 L 54.5 0.5 Q 39.5 20 54.5 39.5 L 0.5 39.5 Q 15.5 20 0.5 0.5 Z" />
        </svg>
        <LinkIcon
          sx={{
            color: theme.palette.onPrimaryContainer.main,
            position: "relative",
            zIndex: 1,
          }}
        />
      </Box>
    </TooltipWithArrow>
  );
};
